let { defaultState } = require('./state.js')

export default {
    reset: (state) => {
        Object.assign(state, defaultState())
        return { ok: true }
    },
    set: (state, payload) => {
        Object.assign(state, payload)
    },
    setTrackForStreamlined: (state, payload) => {
        state.comprehensive = payload.comprehensive
        if (payload.comprehensive) {
            state.thresholdSet = payload.thresholdSet
            state.filterConditions = []
            state.current.panels.forEach(panel => {
                panel.skipForStreamlined = false
            })
            return
        }
        state.thresholdSet = null
        state.filterConditions = payload.conditions
        let ignore = true
        state.current.panels.forEach(panel => {
            if (panel.name === 'summary') {
                ignore = true
            }
            if (!ignore) {
                panel.skipForStreamlined = !payload.panels.includes(panel.name)
            }
            if (panel.name === 'streamlined_options') {
                ignore = false
            }
        })
    }
}
